export default __webpack_public_path__ + "static/media/image-000.e8ca186c.jpg";